import React, { useState } from 'react';
import { IField, TData } from '../../types/forms';
import Form from '../../components/Form/Form';

interface IFormPropTypes {
  fields: Array<IField>;
  handleForm: (data: Partial<TData>) => void;
  formError?: any;
  onEmailStepContinue?: () => Promise<boolean>;
  prefilledEmail?: string | null;
  isMagicLink?: boolean;
  showAllFields?: boolean;
}

const BUTTON_LABELS = {
  ACTIVATE_STEP: 'Activate Account',
  COMPLETE_STEP: 'Create Account',
} as const;
const NOTE = 'Please note, both email and password fields are case-sensitive.';

export const UHCActivationForm = ({
  fields,
  handleForm,
  formError,
  onEmailStepContinue,
  prefilledEmail,
  isMagicLink = false,
  showAllFields = false,
}: Readonly<IFormPropTypes>) => {
  const [revealedFields, setRevealedFields] = useState(() => {
    if (isMagicLink) return fields;
    return fields.length > 0 ? [fields[0]] : [];
  });
  // The page can also reveal the password step (e.g. after re-checking the order from a modal).
  const visibleFields = showAllFields ? fields : revealedFields;
  const isEmailStepOnly = visibleFields.length === 1;

  const showPasswordFields = () => {
    if (onEmailStepContinue) {
      onEmailStepContinue().then(isValid => {
        if (isValid) {
          setRevealedFields(fields);
        }
      });
    }
  };

  const handleClick = (data: Partial<TData>) => {
    if (isEmailStepOnly) {
      showPasswordFields();
    } else {
      handleForm(data);
    }
  };

  return (
    <Form
      fields={visibleFields}
      handleForm={handleClick}
      formError={formError}
      buttonLabel={
        isEmailStepOnly || isMagicLink ? BUTTON_LABELS.ACTIVATE_STEP : BUTTON_LABELS.COMPLETE_STEP
      }
      formData={{
        email: prefilledEmail || '',
      }}
    >
      {!isEmailStepOnly && <p className="register-login-note">{NOTE}</p>}
    </Form>
  );
};
